module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "search"
  }, [_c('cm-messages-filter', {
    staticStyle: {
      "position": "relative",
      "z-index": "10"
    },
    attrs: {
      "isPayments": true,
      "received": false
    }
  }), _vm._v(" "), _c('dp-transactions-list', {
    attrs: {
      "filterBy": _vm.filterBy,
      "outMessages": _vm.sendboxMessages
    }
  }), _vm._v(" "), _c('cm-pagination', {
    attrs: {
      "firstIndex": _vm.sendPaginationObject.firstIndex,
      "maxResultsByPage": _vm.sendPaginationObject.maxResults,
      "nbResultsTotal": _vm.sendPaginationObject.nbResultsTotal,
      "refreshEvent": _vm.sendPaginationObject.refresh
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-61f2f66b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61f2f66b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/services/directPayments/sendbox/SentDP.vue
// module id = 1680
// module chunks = 2